import { render } from "./FlightsView.vue?vue&type=template&id=6ff63ccd&scoped=true"
import script from "./FlightsView.vue?vue&type=script&lang=js"
export * from "./FlightsView.vue?vue&type=script&lang=js"

import "./FlightsView.vue?vue&type=style&index=0&id=6ff63ccd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff63ccd"]])

export default __exports__